var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c(_vm.getSubTab.component,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }